import { makeAutoObservable } from "mobx";

export default class CommonStore {
    isNavbarOpen = false;
    isFilterOpen = false;
    isCelsiusShowed = true;
    isFahrenheitShowed = false;
    isRoutesSelected = true;
    isLaneShipmentsSelected = false;

    isLaneSelected = true;
    isShipmentsSelected = false;

    selectedTab = 0;
    currentView = "";

    userEmail = "";

    popupsCount = 0;

    constructor() {
        makeAutoObservable(this);
    }

    incrementPopupsCount = () => this.popupsCount++;
    decrementPopupsCount = () => this.popupsCount--;
    clearPopupsCount = () => (this.popupsCount = 0);

    setUserEmail = (email: string | undefined) => {
        if (email) {
            this.userEmail = email;
        }
    };

    setSelectedTab = (tab: number) => {
        this.selectedTab = tab;
    };

    setCurrentView = (view: string) => {
        this.currentView = view;
    };

    setLanesSelected = () => {
        this.isShipmentsSelected = false;
        this.isLaneSelected = true;
    };

    setShipmentsSelected = () => {
        this.isLaneSelected = false;
        this.isShipmentsSelected = true;
    };

    setNavbarOpen = () => {
        this.isNavbarOpen = true;
        this.isFilterOpen = false;
    };

    setNavbarClose = () => {
        this.isNavbarOpen = false;
    };

    setFiltersOpen = () => {
        this.isFilterOpen = true;
        this.isNavbarOpen = false;
    };

    setFiltersClose = () => {
        this.isFilterOpen = false;
    };

    setCelsiusShowed = () => {
        this.isFahrenheitShowed = false;
        this.isCelsiusShowed = true;
    };

    setFahrenheitShowed = () => {
        this.isCelsiusShowed = false;
        this.isFahrenheitShowed = true;
    };

    setLaneRoutesSelected = () => {
        this.isLaneShipmentsSelected = false;
        this.isRoutesSelected = true;
    };

    setLaneShipmentsSelected = () => {
        this.isRoutesSelected = false;
        this.isLaneShipmentsSelected = true;
    };
}
